<template>
  <div>
    <div class="menu-item" :class="{ active: active }" @click="changeRoute">
      <svg v-if="icon"
        class="icon"
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        version="1.1"
      >
        <title>{{text}}</title>
        <path :d="icon" id="path-1" />
      </svg>
      <div :title="text">
        <span :is="featherIcon" size="1.5x" class="custom-class"></span>
      </div>
      <span class="item-text">{{ text }}</span>
    </div>
    <div v-if="text == 'Reporting'">
      <transition name="slide-out">
        <sub-menu v-if="reportMenu"></sub-menu>
      </transition>
    </div>

    <div v-if="text == 'Bulk Report'">
      <transition name="slide-out">
        <sub-menu-bulk v-if="reportMenu"></sub-menu-bulk>
      </transition>
    </div>
  </div>
</template>

<script>
  import {
    DollarSignIcon,
    CheckSquareIcon,
    CreditCardIcon,
    MessageCircleIcon,
    ServerIcon,
    FileTextIcon,
    TagIcon,
    FilterIcon,
    ExternalLinkIcon,
    FileIcon,
    CheckCircleIcon,
    GlobeIcon
  } from 'vue-feather-icons'
export default {
  components: {
    SubMenu: () => import("@/components/SubMenuItem.vue"),
    SubMenuBulk: () => import("@/components/SubMenuItemBulk.vue"),
    DollarSignIcon,
    CheckSquareIcon,
    CreditCardIcon,
    MessageCircleIcon,
    ServerIcon,
    FileTextIcon,
    TagIcon,
    FilterIcon,
    ExternalLinkIcon,
    FileIcon,
    CheckCircleIcon,
    GlobeIcon
  },

  props: ["icon", "featherIcon", "text", "route"],
  computed: {
    active() {
      if (this.$route.matched[0] !== undefined) {
        return this.$route.matched[0].name === this.route ||
          (this.$route.matched[0].name.split("-")[2] ==
            this.route.split("-")[2] &&
            this.$route.matched[0].name.split("-")[2] == "reporting")
          ? true
          : false;
      } else {
        return false;
      }
    },
    reportMenu() {
      return this.$route &&
        this.$route.name.split("-")[2] == this.route.split("-")[2]
        ? true
        : false;
    },
  },
  methods: {
    changeRoute() {
      this.$router.push({ name: this.route });
      console.log(this.$route);
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-out-enter-active,
.slide-out-leave-active {
  transition: all 0.3s;
}

.slide-out-enter,
.slide-out-leave-to {
  opacity: 0;
  transform: translateY(-40px);
}
.menu-item {
  cursor: pointer;
  width: 96.6%;
  height: 40px;
  padding-left: 15px;
  border-radius: 0 4px 4px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: white;
  .icon,
  .custom-class{
    width: 30px;
    color: #1e1f20;
  }
  span {
    color: #55616e;
    font-family: "Helvetica Neue";
    font-size: 16px;
    line-height: 20px;
  }
}
.active {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);

  .custom-class {
    * {
      color: white !important;
    }
  }
  span {
    color: #fff;
  }
  .icon {
    fill: #fff;
  }
}
// .menu-item:hover {
//   background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
//   span {
//     color: #fff;
//   }
//   .icon {
//     fill: #fff;
//   }
// }
</style>

